export enum ChannelsListType {
  Recent = 'recent',
  Archived = 'archived',
}
